interface FooterLink {
  key: number;
  title: string;
  linkType: string;
  url: string;
}

export const footerLinksColumn1: FooterLink[] = [
  { key: 1, title: "home", linkType: "link", url: "/" },
  { key: 2, title: "about us", linkType: "hashtag", url: "about" },
  {
    key: 3,
    title: "our team",
    linkType: "link",
    url: "/team",
  },
  {
    key: 4,
    title: "insights",
    linkType: "link",
    url: "/insights",
  },
  {
    key: 5,
    title: "contact",
    linkType: "hashtag",
    url: "contact",
  },
];

export const footerLinksColumn2: FooterLink[] = [
  {
    key: 1,
    title: "insurance",
    linkType: "link",
    url: "/insurance",
  },
  {
    key: 2,
    title: "construction",
    linkType: "link",
    url: "/construction",
  },
  {
    key: 3,
    title: "cyber",
    linkType: "link",
    url: "/cyber",
  },
];

export const footerLinksColumn3: FooterLink[] = [
  {
    key: 1,
    title: "disclaimer",
    linkType: "link",
    url: "/disclaimer",
  },
  {
    key: 2,
    title: "accessibility",
    linkType: "link",
    url: "/accessibility",
  },
  {
    key: 3,
    title: "copyright",
    linkType: "link",
    url: "/copyright",
  },
];
